import { Typography, Box, Box as MuiBox } from '@mui/material'
import { styled } from '@mui/system'

export const CardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  overflowY: 'scroll',
  height: `calc(100cqh - ${200}px)`,
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar ': {
    display: 'none',
  },
}))

export const BlockContent = styled(Typography)(({ theme }) => ({
  display: 'flex',
  fontWeight: 300,
  fontSize: 14,
  lineHeight: 1.6,
  color: theme.palette.grey[900],
}))

export const SideContent = styled(MuiBox)(({ theme, width = 'clamp(480px, 40%, 560px)' }) => ({
  position: 'relative',
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'visible',
  flexDirection: 'row',
  gap: theme.spacing(4),
  width: width,
  minWidth: 320,
  border: 'none',
  borderRadius: 0,
  padding: 0,
  backgroundColor: 'transparent',
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    width: '420px',
  },
}))
